import { Lead } from '../../../../types'
import { ILeadRepository } from '../../infrastructure/repositories'

export class GetLeadUseCase {
 constructor(private leadRepository: ILeadRepository) {}

 async execute(id: string): Promise<Lead> {
 if (!id) {
 throw new Error('ID do lead é obrigatório')
 }
 return this.leadRepository.getById(id)
 }
}

